import React, { CSSProperties, useContext, useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import RootStoreContext, { RootStore } from '../../../storage/RootStore'
import { View } from '../../../storage/Selection'

/// functions
/// types
/// components

interface SelectorProps { }

export const Selector: React.FC<SelectorProps> = observer(() => {


    const style: CSSProperties = {
        margin: '10px 0',
    }

    return (
        // <div style={{ margin: '10px 0', textAlign: 'center', width: '100%', zIndex: 999,  }}>
        <div style={style}>
            <SelectorButton view={'stages'} /> 
            <SelectorButton view={'documents'} /> 
            <SelectorButton view={'problems'} /> 
            <SelectorButton view={'structure'} /> 
        </div>
    )


})




interface SelectorButtonProps {
    view: View
}

const SelectorButton: React.FC<SelectorButtonProps> = observer(({
    view
}) => {

    const {selection} = useContext(RootStoreContext)

    const labels: {
        [v in View]: string
    } = {
        'documents': 'Документи',
        'problems': 'Проблеми',
        'stages': 'Етапи',
        'structure': 'Структура',
    }

    const styleDefault: CSSProperties = {
        border: 0,
        fontSize: '16px',
        cursor: 'pointer',
        fontWeight: 600,
        margin: '5px 15px',
        background: 'transparent',
        borderBottom: 0,
        opacity: 0.35
    }

    const styleSelected: CSSProperties = {
        // borderBottom: '1px solid black',
        opacity: 1
    }

    const style = {
        ...styleDefault,
        ...(selection.view === view ? styleSelected : {})
    
    } 

    return (
        <button style={style} onClick={() => selection.setView(view)}>
            {labels[view]}
        </button>
    )
})